import React from "react";

export const AddOns: React.FunctionComponent = (props) => {
  return <>Add Ons</>;
};
